import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <Typography variant="h4">404</Typography>
      <Typography color="text.secondary">존재하지 않는 페이지입니다.</Typography>
      <Button variant="contained" onClick={() => navigate('/')}>
        홈으로
      </Button>
    </Box>
  );
}
